import {CSSProperties, ReactElement} from "react";

const styles: Record<string, CSSProperties> = {
    content: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minHeight: 0
    }
};

export interface ITabsPanel {
    label: string
    children: ReactElement | ReactElement[]
}
export function TabsPanel({label, children}: ITabsPanel) {
    return (
        <div style={styles.content}>{children}</div>
    );
}